export default __webpack_public_path__ + "static/media/xlsx.4d49568d.png";